<template>
  <v-dialog
    :value="value"
    max-width="460"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @input="$emit('input', $event)"
  >
    <v-card class="scd rounded-lg">
      <div class="scd__head">
        <div class="scd__head-text">
          <h2 class="scd__title">Eliminar enlace</h2>
          <p class="scd__sub">Esta acción es permanente.</p>
        </div>
        <button
          type="button"
          class="scd__close"
          @click="$emit('input', false)"
          aria-label="Cerrar"
        >
          <hero-icon :icon="XMarkIcon" :size="18" />
        </button>
      </div>

      <div class="scd__divider"></div>

      <div class="scd__body">
        <p class="scd__text">
          ¿Seguro que querés eliminar este enlace? No se puede deshacer.
        </p>

        <div class="scd__actions">
          <v-btn text color="primary" class="rounded-lg" @click="$emit('input', false)">
            Cancelar
          </v-btn>
          <v-btn color="error" depressed class="rounded-lg" @click="deleteSocial">
            Eliminar
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteSocial } from '@/graphql/mutations/social'
import HeroIcon from '@/components/shared/HeroIcon'
import XMarkIcon from 'heroicons/24/outline/x-mark.svg'

export default {
  components: { HeroIcon },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    id: {
      type: [Number, String],
      default: null
    }
  },

  data: () => ({
    XMarkIcon
  }),

  methods: {
    deleteSocial () {
      this.$apollo.mutate({
        mutation: DeleteSocial,
        variables: {
          input: {
            id: this.id
          }
        }
      }).then(() => {
        this.$emit('reload')
        this.$emit('input', false)
      })
    }
  }
}
</script>

<style scoped>
.scd {
  background: #fff;
  border: 1px solid #ece7de;
}

.scd__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.scd__title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.scd__sub {
  font-size: 13px;
  color: #756f64;
  margin: 5px 0 0;
}
.scd__close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  transition: background 0.15s ease, color 0.15s ease;
}
.scd__close:hover {
  background: #f1ece3;
  color: #1a1814;
}

.scd__divider {
  height: 1px;
  background: #ece7de;
}

.scd__body {
  padding: 20px 24px 22px;
}
.scd__text {
  font-size: 14px;
  color: #56504a;
  margin: 0;
  line-height: 1.5;
}
.scd__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}
</style>
